<template>
  <div id="footer" class="container-fuild">
      <!-- 电脑端 -->
      <div id="footer_md" class="row hidden-xs hidden-sm">
        <div class="col-md-10 col-md-offset-1 mt_60">
          <div class="left col-md-5 flex flex_column justify_start align_start">
            <p class="fontsize_24 font_600 text_gray pt_10 pb_10">联系方式</p>
            <p class="text_normal fontsize_20 line_height_normal font_600">地址: {{config.address}}</p>
            <p class="text_normal fontsize_20 line_height_normal font_600">电话: 行政部 {{config.tel1}} 业务部 {{config.tel2}}</p>
            <p class="text_normal fontsize_20 line_height_normal font_600">网站: <a target="_blank" class="text_normal fontsize_20 line_height_normal font_600" :href="config.website"> {{config.website}}</a></p>
            <p class="text_normal fontsize_20 line_height_normal font_600">邮箱: <a target="_blank" class="text_normal fontsize_20 line_height_normal font_600" :href="'mailto:'+config.email">{{config.email}}</a></p>
          </div>
          <div class="right col-md-3 col-md-offset-4 flex flex_row justify_between align_center">
            <div class="wechat1 flex flex_column justify_between align_center">
              <p class="fontsize_24 font_600 text_gray pt_10 pb_10">官方微信</p>
              <el-image style="width:100%; height:auto" :src="require('@/assets/img/wechat1.jpg')" fit="contain"></el-image>
            </div>
            <div class="wechat2 flex flex_column justify_between align_center">
              <p class="fontsize_24 font_600 text_gray pt_10 pb_10">人才在线</p>
              <el-image style="width:100%; height:auto" :src="require('@/assets/img/wechat2.jpg')" fit="contain"></el-image>
            </div>
          </div>
          <!-- 备案 -->
          <div class="col-md-12 text_center mt_80">
             <p class="fontsize_16 color_333 font_500">Copyright &copy; 2020 - 2022 <a class="color_333" target="_blank" href="https://beian.miit.gov.cn/">{{config.keepOnRecordIcp}}</a>  {{config.name}}</p>
          </div>
        </div>
       
      </div>

      <!-- 手机端 -->
      <div id="footer_xs" class="row visible-xs visible-sm">
         <div class="col-xs-12 col-xs-offset-0 mt_60">
          <div class="left col-xs-12 flex flex_column justify_start align_start">
            <p class="fontsize_20 font_600 text_gray pt_10 pb_10">联系方式</p>
            <p class="text_normal fontsize_14 line_height_normal font_600">地址: {{config.address}}</p>
            <p class="text_normal fontsize_14 line_height_normal font_600">电话: 行政部 {{config.tel1}} 业务部 {{config.tel2}}</p>
            <p class="text_normal fontsize_14 line_height_normal font_600">网站: <a target="_blank" class="text_normal fontsize_14 line_height_normal font_600" :href="config.website"> {{config.website}}</a></p>
            <p class="text_normal fontsize_14 line_height_normal font_600">邮箱: <a target="_blank" class="text_normal fontsize_14 line_height_normal font_600" :href="'mailto:'+config.email">{{config.email}}</a></p>
          </div>
          <div class="right col-xs-12 col-xs-offset-0 flex flex_row justify_between align_center">
            <div class="wechat1 flex flex_column justify_between align_center">
              <p class="fontsize_20 font_600 text_gray pt_10 pb_10">官方微信</p>
              <el-image style="width:60%; height:auto;" :src="require('@/assets/img/wechat1.jpg')" fit="contain"></el-image>
            </div>
            <div class="wechat2 flex flex_column justify_between align_center">
              <p class="fontsize_20 font_600 text_gray pt_10 pb_10">人才在线</p>
              <el-image style="width:60%; height:auto;" :src="require('@/assets/img/wechat2.jpg')" fit="contain"></el-image>
            </div>
          </div>
          <!-- 备案 -->
          <div class="col-xs-12 text_center mt_20 mb_20">
             <p class="fontsize_14 color_333 font_500">Copyright &copy; 2020 - 2022 <a class="color_333" target="_blank" href="https://beian.miit.gov.cn/">{{config.keepOnRecordIcp}}</a>  {{config.name}}</p>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import config from '@/config'
export default {
  name: "Footer",
  data() {
    return {
      config: config
    };
  }
};
</script>
<style scoped>
.color_blue{
  color: #245998 !important;
}
.bg_blue{
  background-color: #245998 !important;
}
.text_gray{
  color:#6a6a6a;
}
.text_normal{
  /* color: #332E2D; */
  color: #444; /*jet0104 修正整体颜色 */

}

a{
  text-decoration: none; /*去除下划线*/
}
a:hover{
  text-decoration: none; /*去除下划线*/
  color: #245998 !important;
}

#footer{
  width: 100%;
  height: 100%;
}

#footer_md{
  width: 100%;
  height: 450px;
  background: url('../assets/img/footer.jpg') no-repeat center center;
  background-size: cover;
  overflow: hidden;
}

#footer_xs{
  width: 100%;
  min-height: 450px;
  background: url('../assets/img/footer.jpg') no-repeat center center;
  background-size: cover;
  overflow: scroll;
}

</style>




// WEBPACK FOOTER //
// src/components/Footer.vue